import React from 'react';
import config from './particlesConfig.json';
import Particles from 'react-particles-js';
import { ParticlesSectionContainer } from './ParticlesStyle';

const ParticlesContainer = () => {
  return (
    <ParticlesSectionContainer>
      {/*//@ts-ignore*/}
      <Particles params={config}/>
    </ParticlesSectionContainer>
  );
};

export default ParticlesContainer;